import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class MaintenancePractice extends Form {
	state = {
		data: {
			currentPractice: '',
			recommendedPractice: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		currentPractice: Joi.string().min(3).required().label('Current Practice'),
		recommendedPractice: Joi.string().min(3).required().label('Corrective Practice'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

    componentDidMount() {
        if (this.props.initialData) {
            this.setState({ data: this.props.initialData });
        }
    }

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);
		toastService.success('Practice Data Saved Successfully!');
	};


	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderTextEditor({
							name: 'currentPractice',
							placeholder: 'Enter Current Practice',
							label: 'Current Practice',
						})}
					</div>
					
                    <div className="col">
						{this.renderTextEditor({
							name: 'recommendedPractice',
							placeholder: 'Enter Corrective Practice',
							label: 'Corrective Practice',
						})}
					</div>
				</div>

				<div className="divider mt-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Practice Data')}
				</div>
			</form>
		);
	}
}

export default MaintenancePractice;
